import { ITheme } from '@eduact/student-theme'
import { primaryTheme } from './primary.theme'
import { secondaryTheme } from './secondary.theme'
import { abwaabPlusTheme } from './abwaabPlus.theme'

export type ThemeKey = 'primary' | 'secondary' | 'abwaabPlus'

type ThemeMap = { [key in ThemeKey]: ITheme }

export const themesMap: ThemeMap = {
	primary: primaryTheme,
	secondary: secondaryTheme,
	abwaabPlus: abwaabPlusTheme,
}

/** The AbwaabPlus design-system theme is the product default. */
export const DEFAULT_THEME_KEY: ThemeKey = 'abwaabPlus'

/** Legacy theme keys kept selectable, but never auto-selected from the backend. */
export const LEGACY_THEME_KEYS: ThemeKey[] = ['primary', 'secondary']

export const isKnownThemeKey = (key: string | null | undefined): key is ThemeKey =>
	!!key && key in themesMap
